import { Badge } from '@chakra-ui/react';

const TIER_META: Record<
  string,
  { short: string; label: string; colorScheme: string }
> = {
  diamond: { short: '💎', label: 'Diamond', colorScheme: 'purple' },
  elite: { short: '🏆', label: 'Elite', colorScheme: 'yellow' },
  proven: { short: '✓', label: 'Proven', colorScheme: 'green' },
  one_to_watch: { short: '👀', label: 'One to Watch', colorScheme: 'blue' },
  rising: { short: '📈', label: 'Rising', colorScheme: 'teal' },
  unproven: { short: '—', label: 'Unproven', colorScheme: 'gray' },
  cold: { short: '❄', label: 'Cold', colorScheme: 'cyan' },
};

type TierBadgeLiteProps = {
  tier: string;
  compact?: boolean;
};

export function TierBadgeLite({ tier, compact = false }: TierBadgeLiteProps) {
  const key = tier?.trim().toLowerCase() ?? '';
  const meta = TIER_META[key];
  if (!meta) return null;

  return (
    <Badge
      colorScheme={meta.colorScheme}
      variant="subtle"
      fontSize={compact ? '10px' : 'xs'}
      px={compact ? 1.5 : 2}
      py={0.5}
      borderRadius="full"
      textTransform="none"
      fontWeight="semibold"
      flexShrink={0}
    >
      {compact ? `${meta.short} ${meta.label}` : meta.label}
    </Badge>
  );
}
